/** @jsx jsx */

import { Dropdown, Typography } from '@zapier/design-system';
import { jsx, css } from '@emotion/core';

type TimePeriodDaysItem = {
  label: string;
  value: number;
};

type DateRangeDropdownProps<T extends TimePeriodDaysItem> = {
  initialSelectedItem: T;
  items: T[];
  onSelect: (timePeriod: T['value']) => void;
};

const styleRoot = css`
  min-width: 156px;
  & div[class$='Input-Input--root'] {
    ${Typography.Body2};
  }

  & div[class$='FloatingBox--Styles'] {
    ${Typography.Body2};
    width: max-content !important;
  }
`;

export default function DateRangeDropdown<T extends TimePeriodDaysItem>({
  items,
  initialSelectedItem,
  onSelect,
}: DateRangeDropdownProps<T>) {
  return (
    <div css={styleRoot}>
      <Dropdown
        aria-label="Period"
        initialSelectedItem={initialSelectedItem}
        items={items}
        menuAriaLabel="Period Selection"
        onSelect={item => {
          onSelect(item.value);
        }}
        placeholder="Choose a range..."
      />
    </div>
  );
}
